import { Button, Icon } from "Components";
import "./stepfooter.scss";

export interface StepFooterProps {
    onBack: () => void | null;
    onNext: () => void;
    nextBtnText?: string;
    nextBtnDisabled: boolean,
    isLoading?: boolean
}

export default function StepFooter({ onBack, onNext, nextBtnText = "Next", nextBtnDisabled, isLoading = false }: StepFooterProps) {
    const handleNext = (event: React.MouseEvent | MouseEvent) => {
        if (!event.isTrusted) {
            console.warn("Programmatic click detected and blocked!");
            return;
        }
        onNext();
    }
    return <div className="step-footer">
        {onBack && <Button ghost shape="round" type="primary" onClick={onBack}>
            <Icon type="previousPagination" />
            Back
        </Button>}
        <Button shape="round" type="primary" disabled={nextBtnDisabled} className={`next-btn ${nextBtnDisabled ? 'cta-disabled' : ''}`} loading={isLoading} onClick={handleNext}>
            {nextBtnText}
            {nextBtnText === "Next" && <Icon type="campaignPaginationNextBlur" />}
        </Button>
    </div>
}